import React from 'react';
import { Input, Select } from 'antd';
import ReferenceManagement from '../../components/admin/ReferenceManagement/ReferenceManagement';
import {
  fetchGroupeClients,
  createGroupeClient,
  updateGroupeClient,
  deleteGroupeClient,
} from '../../store/slices/referenceSlice';

const { Option } = Select;

const GroupeClientManagement: React.FC = () => {
  const columns = [
    {
      title: 'Nom',
      dataIndex: 'nom',
      key: 'nom',
    },
    {
      title: 'Type client',
      dataIndex: 'type_client',
      key: 'type_client',
    },
    {
      title: 'Contact',
      dataIndex: 'contact',
      key: 'contact',
    },
    {
      title: 'Importance',  // NOUVELLE COLONNE
      dataIndex: 'importance_display',
      key: 'importance',
      render: (text: string, record: any) => (
        <span style={{ 
          color: record.importance >= 4 ? '#52c41a' : 
                 record.importance === 3 ? '#faad14' : '#8c8c8c' 
        }}>
          {text}
        </span>
      ),
    },
  ];

  const formFields = [
    {
      name: 'nom',
      label: 'Nom',
      rules: [{ required: true, message: 'Le nom est obligatoire' }],
      component: <Input placeholder="Nom du groupe client" />,
    },
    {
      name: 'type_client',
      label: 'Type client',
      rules: [],
      component: <Input placeholder="Type de client" />,
    },
    {
      name: 'contact',
      label: 'Contact',
      rules: [],
      component: <Input placeholder="Contact du groupe client" />,
    },
    {
      name: 'importance',  // NOUVEAU CHAMP
      label: 'Importance',
      rules: [{ required: true, message: 'L\'importance est obligatoire' }],
      component: (
        <Select placeholder="Sélectionner l'importance">
          <Option value={1}>très faible</Option>
          <Option value={2}>faible</Option>
          <Option value={3}>moyen</Option>
          <Option value={4}>fréquent</Option>
          <Option value={5}>très fréquent</Option>
        </Select>
      ),
    },
  ];

  return (
    <ReferenceManagement
      type="groupeClients"
      title="Gestion des groupes clients"
      fetchAction={fetchGroupeClients}
      createAction={createGroupeClient}
      updateAction={updateGroupeClient}
      deleteAction={deleteGroupeClient}
      columns={columns}
      formFields={formFields}
    />
  );
};

export default GroupeClientManagement;